module.exports = __webpack_public_path__ + "img/quotation-left.eb97ff50.svg";